<template>
    <div>
        <div class="ranking-board-title"><img src="../../assets/images/ic_arrow.png">
            <span class="title">{{ title }}</span>
            <span v-if="pageTotal>1" class="pager">{{ pageIndex }}/{{ pageTotal }}</span>
        </div>
        <div class="title-border"></div>
    </div>
</template>

<script>


export default {
    name: 'moduleTitle',
    props: {
        title: {
            type: String,
            default: '月度销售达成'
        },
    },
    data() {
        return {
            pageTotal:0,
            pageIndex:1
        }
    },
    methods: {
        setPage(index,total) {
            this.pageIndex=index;
            this.pageTotal=total;
        }
    }
}

</script>

<style lang="less" scoped>
.title-border {
    background: linear-gradient(90deg, #1d7bbc, rgba(29, 123, 188, 0.00));
    width: 100%;
    height: 2px;
}

.ranking-board-title {
    font-weight: bold;
    height: 6vh;
    display: flex;
    align-items: center;
    font-size: 1.1vw;

    img {
        width: 1.1vw;
        height: 1.1vw;
        margin-left: 10px;
        margin-right: 10px;
    }

    .title {
        width: 14vw;
        text-align: left;
    }

    .pager {
        opacity: 0.4;
        font-size: 16px;
        font-weight: normal;
        text-align: right;
        color: #ffffff;
        /* float: right; */
        position: relative;
        right: -7vw;
    }
}
</style>